import { Routes, Route } from 'react-router-dom';
import { PyodideProvider } from './hooks/usePyodide';
import { ProgressProvider } from './hooks/useProgress';
import Home from './pages/Home';
import TopicSelect from './pages/TopicSelect';
import Challenge from './pages/Challenge';
import Progress from './pages/Progress';
import Playground from './pages/Playground';
import UnlockAll from './pages/UnlockAll';
import NotFound from './pages/NotFound';

function App() {
  return (
    <PyodideProvider>
      <ProgressProvider>
        <div className="min-h-screen bg-game-bg">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/topics" element={<TopicSelect />} />
            <Route path="/topic/:topicId" element={<TopicSelect />} />
            <Route path="/challenge/:topicId/:challengeId" element={<Challenge />} />
            <Route path="/progress" element={<Progress />} />
            <Route path="/playground" element={<Playground />} />
            <Route path="/unlock-all" element={<UnlockAll />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </ProgressProvider>
    </PyodideProvider>
  );
}

export default App;
